import { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [hasLoadedCart, setHasLoadedCart] = useState(false);
  
 // Load cart from localStorage on first mount
useEffect(() => {
  const stored = localStorage.getItem('cart');
  if (stored) {
    setCart(JSON.parse(stored));
  }
  setHasLoadedCart(true);
}, []);


// Save to localStorage only after it's loaded once
useEffect(() => {
  if (hasLoadedCart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }
}, [cart, hasLoadedCart]);


  const addToCart = (newItem) => {

    // Find existing index by id
    setCart((prevCart) => {

      const existingIndex = prevCart.findIndex(item => item.id === newItem.id);
    

      if (existingIndex >= 0) {
        const existingItem = prevCart[existingIndex];

        return prevCart.map((item, index) =>
            index === existingIndex
              ? { ...item, quantity: item.quantity + newItem.quantity }
              : item
          );
      } else {
        // New item, add to cart
        return [...prevCart, newItem];
      }
    });
};

// New: Add multiple items at once
  const addMultipleToCart = (items) => {
    setCart((prevCart) => {
      const updatedCart = [...prevCart];

      items.forEach(item => {
        const index = updatedCart.findIndex(p => p.id === item.id);
        if (index > -1) {
          // If product exists, increment quantity by 1
          updatedCart[index] = {
            ...updatedCart[index],
            quantity: updatedCart[index].quantity + 1,
          };
        } else {
          // Add new product with quantity 1
          updatedCart.push({ ...item, quantity: 1 });
        }
      });

      return updatedCart;
    });
  };


  const removeFromCart = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };

  const updateQuantity = (id, quantity) => {
    setCart(cart.map(item => item.id === id ? { ...item, quantity } : item));
  };

  const clearCart = () => {
    setCart([]);
  };

  const selectAddress = (address) => {
    setSelectedAddress(address);
  };

  const clearSelectedAddress = () => {
    setSelectedAddress(null);
  };

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      addMultipleToCart,
      updateQuantity,
      clearCart,
      selectedAddress,
      selectAddress,
      clearSelectedAddress
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
